module.exports = "/dog-racing/img/delete-white.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/delete-white.png
// module id = 1952
// module chunks = 7